




import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class AutoLink extends Vue {
  @Prop({ default: '' }) value!: string

  openUrl () {
    if (!this.value) {
      return
    }
    window.open(this.value)
  }
}
